import { CoinIDType } from '@starsoft/common/enums/coinId';
import { useWalletsMe } from '../../../api';
import { useSearchParams } from '../../useSearchParams';

/**
 * Custom hook to get the coalesced coin ID.
 * This hook retrieves the coin ID from the URL search parameters or from the current wallet account.
 *
 * @returns {Object} An object containing the coin ID.
 *
 * @example
 * // Usage example:
 * const { coinId } = useCoallescedCoinId();
 */
export function useCoallescedCoinId() {
  // Get the URL search parameters
  const search: URLSearchParams = useSearchParams();

  // Retrieve the 'coin-id' parameter from the URL
  const searchCoinId = search.get('coin-id');

  // Get the wallet information using the custom hook
  const { wallet } = useWalletsMe();

  // Determine the coin ID from the URL or fallback to the wallet's current account coin ID
  const coinId =
    (searchCoinId ? (BigInt(searchCoinId) as CoinIDType) : null) ??
    wallet?.currentAccount?.coin?.id;

  // Return the coin ID
  return { coinId };
}
